import { BasePerimeter } from '../perimeters'
import { ROLES } from '@argon/iam/utils'

export default new BasePerimeter({
  purpose: 'organization',
  can: {
    // TODO: organizations don't seem to have the `actions` attribute
    update(organization) {
      return this.isLevelOrAbove(organization, ROLES.MANAGER)
    },
    destroy(organization) {
      return this.isLevelOrAbove(organization, ROLES.OWNER)
    },
    read() {
      return this.isAuthenticated()
    },
    manage() {
      return this.atLeastManager()
    },
    create() {
      return true // Everyone can create an organization.
      // return this.hasPermission('organization:create')
    },
    administrate() {
      return this.isAdmin()
    },
    atLeastMember() {
      let org = this.child.getters['organizations/activeOrg']
      return this.isLevelOrAbove(org, ROLES.MEMBER)
    },
    atLeastManager() {
      let org = this.child.getters['organizations/activeOrg']
      return this.isLevelOrAbove(org, ROLES.MANAGER)
    }
  }
})
